import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  FiHome, FiBook, FiFileText, FiClipboard,
  FiCheckSquare, FiGrid, FiFolder, FiCalendar,
  FiSearch, FiLogOut,
} from 'react-icons/fi';
import { useAuth } from '../../../contexts/AuthContext';
import './TeacherSidebar.css';

const navItems = [
  { to: '/teacher/dashboard', icon: FiHome, label: 'Dashboard' },
  { to: '/teacher/classes', icon: FiBook, label: 'Classes' },
  { to: '/teacher/assignments', icon: FiFileText, label: 'Assignments' },
  { to: '/teacher/assessments', icon: FiClipboard, label: 'Assessments' },
  { to: '/teacher/grading', icon: FiCheckSquare, label: 'Grading' },
  { to: '/teacher/gradebook', icon: FiGrid, label: 'Gradebook' },
  { to: '/teacher/library', icon: FiFolder, label: 'Library' },
  { to: '/teacher/calendar', icon: FiCalendar, label: 'Calendar' },
  { to: '/teacher/search', icon: FiSearch, label: 'Search' },
];

function TeacherSidebar() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <aside className="teacher-sidebar" aria-label="Teacher Portal navigation">
      <div className="teacher-sidebar__header">
        <div className="teacher-sidebar__logo">
          <img
            src="/logos/docuhounds-logo.svg"
            alt="DocuHounds"
            className="teacher-sidebar__logo-img"
            onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'block'; }}
          />
          <span className="teacher-sidebar__logo-text" style={{ display: 'none' }}>DocuHounds</span>
        </div>
        <span className="teacher-sidebar__badge">Teacher Portal</span>
      </div>

      <nav className="teacher-sidebar__nav">
        {navItems.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              `teacher-sidebar__item ${isActive ? 'teacher-sidebar__item--active' : ''}`
            }
          >
            <item.icon className="teacher-sidebar__item-icon" size={18} />
            <span className="teacher-sidebar__item-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="teacher-sidebar__footer">
        <button className="teacher-sidebar__logout" onClick={handleLogout}>
          <FiLogOut size={16} />
          <span>Sign Out</span>
        </button>
      </div>
    </aside>
  );
}

export default TeacherSidebar;
